/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author Soongjin Park
 * @contact sjpark@detech.co.kr
 * @date 2022-09-05
 * @brief EHP 메시지 관리 개발
 *
 ********************************************************************/
import React from "react";
//component
import AlarmMsgList from "./AlarmMsgList";
/**
 * @brief EHP 메시지 관리 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function AlarmCRUD(props) {
    //const [isMobile, setIsMobile] = useState(false);
    //const [adminType, setAdminType] = useState("ZONE"); // ZONE, SUBZONE, ROOM
    //props
    const isMobile = props.isMobile;
    const adminType = props.adminType;
    const setParentAdminType = props.setAdminType;
    const selTree = props.selTree;
    const setParentSelTree = props.setSelTree;
    const workMode = props.workMode;
    const setParentWorkMode = props.setWorkMode;
    return (React.createElement(React.Fragment, null, (workMode === "LIST") &&
        React.createElement(AlarmMsgList, { isMobile: props.isMobile, setIsMobile: props.setIsMobile, selTree: selTree, setSelTree: props.setSelTree, 
            //setAdminType={props.setAdminType}
            workMode: props.workMode, setWorkMode: props.setWorkMode, setPopWin: props.setPopWin })));
}
;
export default AlarmCRUD;
